@if (viewType === layoutType.LIST) {
<div class="component-wrapper d-block h-100 pointer-events-none" [ngStyle]="contentStyle">
  @if (widgetConfig.inputFieldSettings?.isAllowed) {
  <div
    class="search-input d-flex"
    [ngStyle]="{ 'justify-content': widgetConfig.inputFieldSettings?.css_config?.inputPosition ?? 'start' }"
  >
    <div
      [ngStyle]="{
        width:
          widgetConfig?.inputFieldSettings?.css_config?.inputWidth !== null
            ? widgetConfig?.inputFieldSettings?.css_config?.inputWidth + '%'
            : '100%'
      }"
    >
      <finxone-input
        type="text"
        [placeholder]="widgetConfig.inputFieldSettings?.label ?? ''"
        (input)="searchAccounts($event)"
      >
        <span prefix #prefix class="prefix-icon" *ngIf="widgetConfig.icon">
          <mat-icon [svgIcon]="widgetConfig.icon" [ngStyle]="searchIconStyle"></mat-icon> </span
      ></finxone-input>
    </div>
  </div>
  <div class="py-5"></div>
  } @if (widgetConfig?.['orientation'] === 'vertical') {
  <ng-container
    *ngTemplateOutlet="verticalLayout; context: {
      widgetConfig: widgetConfig,
      accountsData: listingAccountsData,
      searchText: searchText,
      isApiInProgress: listingApiInProgress,
      textContentStyle: textContentStyle,
    }"
  ></ng-container>
  } @if (widgetConfig?.['orientation'] === 'horizontal') { @if(listingAccountsData.length) {
  <finxone-web-frontend-common-carousel
    [accountContext]="context"
    [widgetName]="WidgetNames.ACCOUNT_LIST_WIDGET"
    [accountsData]="listingAccountsData"
    [templateFunction]="templateFunction"
    [baseHandleBarModel]="baseHandleBarModel"
    [activeAccountIndex]="activeAccountIndex"
    (itemClicked)="onAccountClick($event)"
    (activeIndexUpdate)="fetchNewAccounts($event)"
    [currencies]="currencies"
    [countries]="countries"
    [carouselItemHeight]="carouselItemStyles.height ?? 'auto'"
    [carouselItemWidth]="carouselItemStyles.width ?? 'auto'"
    [carouselItemWidthUnit]="carouselItemStyles.widthUnit ?? '%'"
    (scrolled)="onCarouselScroll()"
  ></finxone-web-frontend-common-carousel>
  } @else { @if (searchText.length) {
  <ng-container *ngTemplateOutlet="emptySearchResults; context: { searchText: searchText }"></ng-container>
  } @else if(listingApiInProgress){
  <div class="row mx-0">
    <div class="col-12">
      <div class="col-12" [innerHTML]="renderFetchingTemplate() | safeHtml"></div>
    </div>
  </div>
  } @else {
  <div class="row mx-0">
    <div class="col-12" [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
  </div>
  } } }
</div>

<ng-template
  #verticalLayout
  let-widgetConfig="widgetConfig"
  let-accountsData="accountsData"
  let-searchText="searchText"
  let-isApiInProgress="isApiInProgress"
  let-textContentStyle="textContentStyle"
>
  <div
    class="list-wrapper scrollable pb-2"
    id="account-listing"
    (scroll)="onScroll($event)"
    [ngStyle]="
      !pageConfig?.isUsingHtmlStructure
        ? { 'max-height': widgetConfig.inputFieldSettings?.isAllowed ? '85%' : 'unset' }
        : { 'max-height': containerHeight }
    "
  >
    @for (account of accountsData; track account.accountId;) {
    <finxone-web-frontend-list-item
      [textContentStyle]="textContentStyle"
      [customHandlebarModel]="accountsHandleBarModel(account, $index)"
      [content]="getContentTemplate()"
      (itemClicked)="onAccountClick(account)"
      [customClass]="'mb-5 pointer-events-none'"
      [gestures]="dataIn?.attri?.widgetProperties?.gestures"
      [listActions]="dataIn?.attri?.['listActions']"
      (actionTriggered)="onListSwipeAction($event, account)"
    ></finxone-web-frontend-list-item>
    } @empty { @if (searchText.length) {
    <ng-container *ngTemplateOutlet="emptySearchResults; context: { searchText: searchText }"></ng-container>
    } @else if(isApiInProgress){
    <div class="row mx-0">
      <div class="col-12">
        <div class="col-12" [innerHTML]="renderFetchingTemplate() | safeHtml"></div>
      </div>
    </div>
    } @else {
    <div class="row mx-0">
      <div class="col-12" [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
    </div>
    } }
  </div>
</ng-template>

<ng-template #emptySearchResults let-searchText="searchText">
  <div class="empty-screen-msg">
    <div class="is-center mb-3">
      <mat-icon [svgIcon]="'exclamation-circle'"></mat-icon>
    </div>
    <p>
      No results found for <b>{{ '"' + searchText + '"' }}</b
      >. Check the spelling or try another search.
    </p>
  </div>
</ng-template>

}@if (viewType === layoutType.TABLE) {
<finxone-web-frontend-desktop-listing
  [entityData]="listingAccountsData"
  [dataIn]="dataIn"
  [totalListCount]="totalListCount"
  [pageNumber]="pageNumber"
  (pageChange)="onPageChange($event)"
  [actionOptions]="actionOptions"
  [enableClickableRow]="enableClickableRow"
  [menuPopupCss]="menuPopupCss"
  [isApiInProgress]="listingApiInProgress"
  [uniqueId]="'accountId'"
  (rowData)="onAccountClick($event)"
  (actionEvent)="handleTableAction($event)"
  (performAction)="handleTableMenuOptionAction($event)"
  (searchValueText)="searchValue($event)"
></finxone-web-frontend-desktop-listing>
}
